"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mainModule = _interopRequireDefault(require("./main.module.css"));
var _oneWeir = require("@weirgroup/one-weir");
var _weirDls = require("@weirgroup/weir-dls");
var _userdetailsConstants = require("../userdetailsConstants");
var _manageYourTeam = require("../../manageYourTeam.action");
var _reactRedux = require("react-redux");
var _languageMsg = _interopRequireDefault(require("../../viewusers/languageMsg"));
var _constants = require("../../constants");
var _common = require("../../../../utilities/common");
class MineSites extends _react.default.Component {
  constructor(props) {
    super(props);
    const setRoleValue = [...this.props.appDetails];
    setRoleValue.map(item => {
      Object.assign(item, {
        value: item.appRoleObjectId,
        label: item.appRoleDisplayName,
        name: item.appRoleDisplayName
      });
      return item;
    });
    this.state = {
      value: setRoleValue
    };
  }
  componentDidMount() {
    this.props.fetchMineSiteInfo(this.props.appinfo, this.props.selectedUser.MineSiteUserObjectId.source);
  }
  updateUsersAppRole(selectedRole, oldRoleData, e) {
    try {
      if (selectedRole) {
        var _oldRoleData$appsrcsy, _selectedRole$, _this$props$selectedU, _this$props$selectedB;
        const reqBody = {
          applicationID: this.props.appinfo.appid,
          appRoleObjectId: oldRoleData === null || oldRoleData === void 0 || (_oldRoleData$appsrcsy = oldRoleData.appsrcsysmapping) === null || _oldRoleData$appsrcsy === void 0 || (_oldRoleData$appsrcsy = _oldRoleData$appsrcsy.source) === null || _oldRoleData$appsrcsy === void 0 ? void 0 : _oldRoleData$appsrcsy.roleObjectId,
          updatedAppRoleId: (_selectedRole$ = selectedRole[0]) === null || _selectedRole$ === void 0 ? void 0 : _selectedRole$.appRoleObjectId,
          userObjectId: (_this$props$selectedU = this.props.selectedUser) === null || _this$props$selectedU === void 0 || (_this$props$selectedU = _this$props$selectedU.MineSiteUserObjectId) === null || _this$props$selectedU === void 0 ? void 0 : _this$props$selectedU.source,
          businessEntityObjectId: (_this$props$selectedB = this.props.selectedBusinessEntity) === null || _this$props$selectedB === void 0 ? void 0 : _this$props$selectedB.businessEntityObjectId,
          appInfo: this.props.appinfo
        };
        this.props.updateUserRole(reqBody);
      }
    } catch (e) {
      console.log('mineSitesUserRole', e);
    }
  }
  getAssignedMinesites(props) {
    const dataList = props.mineSiteInfo;
    const appDetails = props.appDetails;
    // roles data
    let rolesList = [];
    if (appDetails) {
      const dropdownData = appDetails;
      const roles = (0, _common.formatRoleDropDownValues)(dropdownData, 'appRoleDisplayName');
      rolesList = roles.roleNames.filter((thing, ind, self) => ind === self.findIndex(t => t.value === thing.value));
    }
    const RoleDropdown = roleData => {
      var _rolesList$filter$;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_weirDls.Dropdown, {
        selectData: rolesList,
        selectSize: 4,
        size: "md",
        name: "selectApp",
        placeholderText: _userdetailsConstants.userDetailsConstants.AUTOSEARC_PLACEHOLDER,
        setValue: e => {
          var _roleData$data;
          if ((roleData === null || roleData === void 0 || (_roleData$data = roleData.data) === null || _roleData$data === void 0 || (_roleData$data = _roleData$data.roleVal) === null || _roleData$data === void 0 ? void 0 : _roleData$data.source) !== e) {
            var _rolesList;
            console.log('setValue', e);
            const result = (_rolesList = rolesList) === null || _rolesList === void 0 ? void 0 : _rolesList.filter(obj => {
              return obj.name === e;
            });
            this.updateUsersAppRole(result, roleData === null || roleData === void 0 ? void 0 : roleData.data, e);
          }
        },
        value: (_rolesList$filter$ = rolesList.filter(option => option.appRoleDisplayName === roleData.data.roleVal.source)[0]) === null || _rolesList$filter$ === void 0 ? void 0 : _rolesList$filter$.value
      }));
    };
    const DeleteButton = rowData => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _mainModule.default.cellWrapper,
        "data-test": 'delete'
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: _mainModule.default.iconWrap,
        onClick: e => this.deleteMineSite(rowData.data.appsrcsysmapping.source)
      }, /*#__PURE__*/_react.default.createElement(_oneWeir.Icon, {
        width: "16px",
        height: "16px",
        icon: "trash"
      })));
    };
    const tableData = {
      tableHeaders: [{
        label: this.props.mineSiteLabel.singular,
        sortable: true,
        type: 'string',
        key: 'minesiteName'
      }, {
        label: _userdetailsConstants.userDetailsConstants.ROLE,
        sortable: true,
        filterable: true,
        key: 'roleVal',
        renderFn(data) {
          return /*#__PURE__*/_react.default.createElement(RoleDropdown, {
            data: data
          });
        }
      }, {
        label: _userdetailsConstants.userDetailsConstants.REMOVE_ACCESS,
        sortable: false,
        renderFn(data) {
          return /*#__PURE__*/_react.default.createElement(DeleteButton, {
            data: data
          });
        }
      }],
      data: []
    };
    dataList && dataList.length && dataList.map(userDetails => {
      userDetails.applicationSourceSystemMappings.map(appsrcsysmapping => {
        appsrcsysmapping.sourceSystemMappings.map(srcsystemmapping => {
          tableData.data.push({
            'minesiteName': srcsystemmapping.sourceSystemBusinessEntityDisplayName || '-',
            'roleVal': appsrcsysmapping.roleDisplayName,
            'removeAction': '',
            appsrcsysmapping
          });
        });
      });
    });
    this.setState(() => ({
      tableHeaders: null,
      tableSrcData: null
    }), () => {
      this.setState({
        tableHeaders: tableData.tableHeaders,
        tableSrcData: tableData.data
      });
    });
    return tableData;
  }
  deleteBodyContent(userName) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.modalText
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.contentOne
    }, "".concat(_languageMsg.default.DELETE_CONFIRMATION, " ").concat(userName, "?")));
  }

  /**
   * Triggered when clicked on Remove access button from Delete Modal
   * @param data 
   */
  deleteMineSiteInfo(data) {
    var _this$props$selectedU2, _this$props$selectedU3;
    const reqBody = {
      appRoleObjectId: data.roleObjectId,
      userObjectId: (_this$props$selectedU2 = this.props.selectedUser) === null || _this$props$selectedU2 === void 0 || (_this$props$selectedU2 = _this$props$selectedU2.MineSiteUserObjectId) === null || _this$props$selectedU2 === void 0 ? void 0 : _this$props$selectedU2.source,
      MineSiteUserappRoleObjectId: {
        source: data.roleObjectId,
        value: data.roleObjectId
      },
      MineSiteUserObjectId: (_this$props$selectedU3 = this.props.selectedUser) === null || _this$props$selectedU3 === void 0 ? void 0 : _this$props$selectedU3.MineSiteUserObjectId,
      appInfo: this.props.appinfo
    };
    this.props.deleteMineConf(this.props.appinfo.appid, reqBody, this.props.selectedBusinessEntity);
  }

  /**
   * Triggered when clicked on delete icon 
   * @param roleInfo 
   */
  deleteMineSite(roleInfo) {
    this.props.deleteMineSite(roleInfo);
  }
  deleteFooterContent(props) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.footerContent
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.margin25
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Button, {
      disabled: false,
      label: _userdetailsConstants.userDetailsConstants.CANCEL_BUTTON,
      variant: "secondary",
      onClick: () => {
        props.deleteMineSite(this.props.deleteMineData);
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.margin25
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Button, {
      disabled: false,
      label: _userdetailsConstants.userDetailsConstants.RM_ACCESS_BUTTON,
      variant: "primary",
      onClick: () => {
        this.deleteMineSiteInfo(this.props.deleteMineData);
      }
    })));
  }
  onClickAddTeamMember() {
    this.props.addTeamMemberCallback();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.mineSiteInfo !== this.props.mineSiteInfo) {
      this.getAssignedMinesites(this.props);
    }
  }
  render() {
    const userDisplayName = this.props.selectedUser && this.props.selectedUser.MineSiteUsers ? this.props.selectedUser.MineSiteUsers.source : '';
    const {
      tableHeaders,
      tableSrcData
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "minesites-table",
      className: _mainModule.default.wrapper
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Modal, {
      showModal: this.props.Modal,
      onClose: () => {
        this.props.deleteMineSite();
      },
      size: 'small',
      dismissable: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.modalPadding
    }, this.deleteBodyContent(userDisplayName), this.deleteFooterContent(this.props))), tableSrcData && /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.paddingTop20
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Table, {
      header: tableHeaders,
      source: tableSrcData,
      searchable: true,
      sortable: true,
      searchPlaceholder: _constants.tableConstants.SEARCH_PLACEHOLDER_ONBLUR,
      title: "".concat(_userdetailsConstants.userDetailsConstants.MINESITES_HEADING.replace('<MineSiteLabelPlural>', this.props.mineSiteLabel.plural), " : ").concat(this.props.selectedUser.MineSiteUsersEmail.source),
      searchPlaceHolderOnBlur: _constants.tableConstants.SEARCH_PLACEHOLDER_ONBLUR,
      searchPlaceHolderOnFocus: _constants.tableConstants.SEARCH_PLACEHOLDER_ONFOCUS,
      noResultsText: _constants.tableConstants.NO_RESULTS_LBL,
      searchResultSingle: _constants.tableConstants.RESULTS_LBL_SINGULAR,
      searchResultPlural: _constants.tableConstants.RESULTS_LBL_PLURAL,
      primaryActionBtnTitle: _userdetailsConstants.userDetailsConstants.BUTTON_LABEL.replace('<MineSiteLabelPlural>', this.props.mineSiteLabel.plural),
      onPrimaryActionBtnClick: () => this.onClickAddTeamMember(),
      tableType: "small"
    })));
  }
}
function mapDispatchToProps(dispatch) {
  return {
    fetchMineSiteInfo: (appInfo, userObjectId) => {
      dispatch((0, _manageYourTeam.fetchMineSiteInfo)(appInfo, userObjectId));
    },
    updateUserRole: reqBody => {
      dispatch((0, _manageYourTeam.updateUserRole)(reqBody));
    }
  };
}
const mapStateToProps = state => ({
  appinfo: state.manageYourTeam.appinfo,
  mineSiteInfo: state.manageYourTeam.mineSiteInfo,
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MineSites);